import React, { useEffect, useState } from 'react'
import { Box, List, Text } from 'grommet'
import CalendarEventSummary from './CalendarEventSummary'
import SearchBar from './SearchBar'
import { I18n } from 'galarm-config'

const CalendarEventList = ({ events, showSearchBar, hideSearchBar }) => {
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    if (!showSearchBar) {
      setSearchText('')
    }
  }, [showSearchBar])

  let filteredEvents = events.filter(
    event =>
      (event.summary || '').toLowerCase().includes(searchText.toLowerCase()) ||
      (event.description || '').toLowerCase().includes(searchText.toLowerCase())
  )

  return (
    <Box flex={{ shrink: 0 }}>
      {showSearchBar && (
        <SearchBar
          onChangeText={setSearchText}
          searchText={searchText}
          onCloseSearchBar={hideSearchBar}
          focus
        />
      )}
      {filteredEvents.length === 0 ? (
        <Box pad="medium" flex justify="center" align="center">
          <Text color="textColor">{I18n.t('noEvents')}</Text>
        </Box>
      ) : (
        <List
          border={false}
          margin={{ vertical: 'small' }}
          pad={{ vertical: 'xsmall', horizontal: 'small' }}
          data={filteredEvents}>
          {(item, index) => (
            <CalendarEventSummary key={item.id || index} {...item} />
          )}
        </List>
      )}
    </Box>
  )
}

export default CalendarEventList
